import { Helmet } from 'react-helmet-async';

import { OPTIMIZELY_WEB_ENABLED } from '@constants/config';

export const OptimizelyWebExperimentation = () => {
  return (
    <>
      {process.env.E2E_TESTS !== 'true' && OPTIMIZELY_WEB_ENABLED && (
        <Helmet>
          <script
            src="https://cdn.optimizely.com/js/5240464253648896.js"
            type="text/javascript"
          />
        </Helmet>
      )}
    </>
  );
};
